module.exports = __webpack_public_path__ + "img/media-warranty.68d6a92b.svg";